import React from 'react'

export interface SwiperBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  data: {
    list: any[]
    configuration?: any
    onVideoPlayBtnClick?: (jIndex: number) => void
  }
  id: string
  itemClassName?: string
  breakpoints?: Record<number, Object>
  Slide: React.ComponentType<{ data: any; configuration?: any; jIndex?: number }>
}
